import BaseModule from "./base-module";

class PublicApi extends BaseModule {
  constructor() {
    super(process.env.VUE_APP_API_BASE_DOMAIN);
  }
  getDeliveyBanner(params) {
    return this.get("/getShareimg", { params });
  }
}

export default new PublicApi();
